import axios, { AxiosError, InternalAxiosRequestConfig } from "axios"

import { addAuthorizationHeader, retryWrapper } from "./helpers"

const analyticsAxiosInstance = axios.create({
  baseURL: process.env.NEXT_PUBLIC_ANALYTICS_API,
})

analyticsAxiosInstance.interceptors.request.use(
  async (config: InternalAxiosRequestConfig) => {
    // eslint-disable-next-line no-param-reassign
    config = await addAuthorizationHeader(config)

    return config
  },
  (error: AxiosError) => {
    return Promise.reject(error)
  }
)

retryWrapper(analyticsAxiosInstance, {
  retryTimes: 0,
})

export default analyticsAxiosInstance
